module.exports = __webpack_public_path__ + "img/MA.c832c174.svg";